import styled, { css } from "styled-components";

export const Container = styled.div<{ hasError: boolean }>`
  display: flex;
  flex-direction: column;
  width: 100%;

  ${(props) => props.hasError && css`
    --field-border: ${props.theme.colors.error};
    --field-label: ${props.theme.colors.error};
  `}
`;

export const Field = styled.div`
  position: relative;
  width: 100%;

  input {
    width: 100%;
    padding: 18px 14px 8px;
    font-size: 15px;
    line-height: 1.4;
    color: ${(props) => props.theme.brand.ink};
    background: #ffffff;
    border: 1px solid var(--field-border, ${(props) => props.theme.brand.line});
    border-radius: 8px;
    outline: none;
    transition: border-color 0.15s ease, box-shadow 0.15s ease;
  }

  input:hover {
    border-color: ${(props) => props.theme.brand.soft};
  }

  input:focus {
    border-color: var(--field-border, ${(props) => props.theme.brand.navyMed});
    box-shadow: 0 0 0 3px rgba(41, 104, 168, 0.18);
  }

  input::placeholder {
    color: transparent;
  }
`;

export const Label = styled.label`
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  padding: 0 4px;
  font-size: 15px;
  color: var(--field-label, ${(props) => props.theme.brand.muted});
  background: #ffffff;
  pointer-events: none;
  transition: top 0.15s ease, font-size 0.15s ease, color 0.15s ease;

  ${Field} input:focus + &,
  ${Field} input:not(:placeholder-shown) + & {
    top: 0;
    font-size: 12px;
    color: var(--field-label, ${(props) => props.theme.brand.navyMed});
  }
`;

export const Error = styled.span`
  margin-top: 6px;
  font-size: 12px;
  color: ${(props) => props.theme.colors.error};
`;
